import { Link } from "react-router-dom";

export default function Footer() {
  const go = (e, href) => {
    e.preventDefault();
    if (href === "#") window.scrollTo({ top: 0, behavior: "smooth" });
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  const links = [
    ["Accueil", "#", "accueil"],
    ["Prestations", "#prestations", "prestations"],
    ["Tatouage", "#tatouage", "tatouage"],
    ["Galerie", "#galerie", "galerie"],
    ["À propos", "#apropos", "apropos"],
    ["Avis", "#avis", "avis"],
    ["Contact", "#contact", "contact"],
    ["Rendez-vous", "#reservation", "rendezvous"],
  ];

  return (
    <footer className="border-t border-[var(--brand-bg)]/10 bg-[var(--brand-dark)] px-6 py-20 text-[var(--brand-bg)] lg:px-12" data-testid="footer">
      <div className="mx-auto max-w-7xl">
        <p className="font-display text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-none">
          Beauty <span className="italic font-light text-[var(--brand-accent)]">by</span> Armina
        </p>
        <div className="mt-14 flex flex-wrap items-end justify-between gap-10 border-t border-[var(--brand-bg)]/10 pt-10">
          <nav className="flex flex-wrap gap-x-8 gap-y-4">
            {links.map(([label, href, slug]) => (
              <a key={slug} href={href} onClick={(e) => go(e, href)}
                 className="text-xs uppercase tracking-[0.25em] text-[var(--brand-bg)]/60 transition-colors duration-300 hover:text-[var(--brand-accent)]"
                 data-testid={`footer-link-${slug}`}>
                {label}
              </a>
            ))}
          </nav>
          <div className="flex flex-col items-start gap-3 sm:items-end">
            <Link to="/admin" className="text-xs uppercase tracking-[0.25em] text-[var(--brand-bg)]/40 transition-colors duration-300 hover:text-[var(--brand-accent)]" data-testid="footer-admin-link">
              Espace professionnel
            </Link>
            <p className="text-xs font-light text-[var(--brand-bg)]/40">© {new Date().getFullYear()} Beauty by Armina — Tous droits réservés</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
